import { DealDetails } from './DealDetails';

export class Article {
    constructor(article?: Partial<Article>) {
        Object.assign(this, article);
    }

    articleId: number;
    title: string;
    imgUrl: string;
    desc: string;
    date: Date;
    isSelected: boolean;
    dealCount: number;
    isActive: boolean;
    isGiftList: boolean;
    pageTitle: string;
    hypotenuseCatalogName: string;
    permalink: string;
    deals: DealDetails[];
    tags: TagDetails[];
    primaryTag: TagDetails;
    prettyTitle: string;
} 

export class ArticleTag {
    tagID?: number; // Backend sends tagID (acronym kept uppercase), map to tagId
    tagId: number = 0;
    articleID?: number; // Backend sends articleID (acronym kept uppercase), map to articleId
    articleId: number = 0;
    tagName: string = '';
    isSelected: boolean = false;
    sortOrder: number = 0;
    permalink: string = '';

    constructor(articleTag?: Partial<ArticleTag>) {
        Object.assign(this, articleTag);
        // Map tagID (from backend camelCase with uppercase acronym) to tagId (frontend convention)
        if (this.tagID !== undefined && this.tagID !== null) {
            this.tagId = this.tagID;
        }
        // Map articleID (from backend camelCase with uppercase acronym) to articleId (frontend convention)
        if (this.articleID !== undefined && this.articleID !== null) {
            this.articleId = this.articleID;
        }
    }
} 


export class TagDetails {
    constructor(tagDetails?: Partial<TagDetails>) {
        Object.assign(this, tagDetails);
    }
    articleId: number | null;
    tagId: number | null;
} 